var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import './richText.scss';
import parse from 'html-react-parser';
var RichText = function (prop) {
    var featureArray = prop.data;
    return (featureArray.copy && (_jsx("div", __assign({ className: "richText-section" }, { children: parse(featureArray.copy) }), void 0)));
};
export default RichText;
